'use strict';

var React = require('react');
var compose = require('../hoc/compose');
var template = require('./helpButton.rt');
var displayNames = require('./displayNames');

var HelpButton = template;

HelpButton.displayName = displayNames.HELP_BUTTON;
HelpButton.propTypes = {
    onClick: React.PropTypes.func
};
//TODO: Implement help button with '?' as SVG instead of character
module.exports = compose(HelpButton);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/helpButton.js